import { render, staticRenderFns } from "./GoodsTypes.vue?vue&type=template&id=52085208"
import script from "./GoodsTypes.vue?vue&type=script&lang=js"
export * from "./GoodsTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports